import { ui } from '@procuros/datachecks';
import isEqual from 'lodash/isEqual';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type State = {
  uiConfig: Array<ui.Section>;
  isLoading: boolean;
};

export const initialState: State = {
  uiConfig: [],
  isLoading: true,
};

export const useTaskStore = create(
  immer<State>(() => ({
    ...initialState,
  })),
);

export const setUiConfig = (uiConfig: Array<ui.Section>) =>
  useTaskStore.setState((state) => {
    if (isEqual(state.uiConfig, uiConfig)) {
      return state;
    }
    return { uiConfig };
  });

export const setIsLoading = (isLoading: boolean) => useTaskStore.setState({ isLoading });

export const cleanStore = () => useTaskStore.setState(initialState);
